import { IUsageFeeTierKey, type IUsageFeeTier } from '../../types';

import { usePricingUsageFeeTier } from './usePricingUsageFeeTier';
import { usePricingPlanActive } from '../usePricingPlanActive';
import { useUsageFeeBillStore } from '../../stores';
import { MAX_PRICE_RANGE } from '../../constants';
import { useMemo } from 'react';

interface IPricingUsageFeeCurrent {
  isHasUsageFeeCurrent: boolean;
  cycleStartDate: string;
  cycleEndDate: string;
  usageAmount: number;
  price: number;
  usageFeeTier?: IUsageFeeTier;
  isMediumTier: boolean;
  isBasicTier: boolean;
  isOverBasicTier: boolean;
  progress: number | null;
  minFeeTier: number;
  maxFeeTier: number;
}

export const usePricingUsageFeeCurrent = (): IPricingUsageFeeCurrent => {
  const { usageFeeCurrent } = useUsageFeeBillStore();
  const { usageFeeTiersByPlan } = usePricingUsageFeeTier();
  const { activePlan } = usePricingPlanActive();

  const isHasUsageFeeCurrent = getIsHasUsageFeeCurrent();
  const cycleStartDate = usageFeeCurrent?.cycleStartDate ?? '';
  const cycleEndDate = usageFeeCurrent?.cycleEndDate ?? '';
  const usageAmount = Number(usageFeeCurrent?.usageAmount ?? 0);
  const price = Number(usageFeeCurrent?.price ?? 0);

  const usageFeeTier = useMemo(() => {
    return usageFeeTiersByPlan?.find(({ max }) => max >= usageAmount);
  }, [usageAmount, usageFeeTiersByPlan]);

  const isBasicTier = usageFeeTier?.tierKey === IUsageFeeTierKey.BASIC;
  const isOverBasicTier = !!usageFeeTier && !isBasicTier;
  const isMediumTier = usageFeeTier?.tierKey === IUsageFeeTierKey.MEDIUM;

  const minFeeTier = usageFeeTier?.min ?? 0;
  const maxFeeTier = usageFeeTier?.max ?? 0;
  const progress = calculateProgress();

  return {
    cycleStartDate,
    cycleEndDate,
    usageAmount,
    price,
    usageFeeTier,

    progress,
    minFeeTier,
    maxFeeTier,

    isBasicTier,
    isMediumTier,
    isOverBasicTier,
    isHasUsageFeeCurrent,
  };

  function getIsHasUsageFeeCurrent(): boolean {
    const activePlanId = activePlan?.id;
    const isHasUsageFeeTier = usageFeeTiersByPlan?.find(({ planID }) => planID === activePlanId);

    return !!isHasUsageFeeTier;
  }

  function calculateProgress(): number | null {
    // if (maxFeeTier === MAX_PRICE_RANGE) {
    //   return ((usageAmount - minFeeTier) / (MAX_PRICE_RANGE_PROCESSING - minFeeTier)) * 100;
    // }
    if (maxFeeTier === MAX_PRICE_RANGE) return null;

    if (!maxFeeTier) return null;
    return ((usageAmount - minFeeTier) / (maxFeeTier - minFeeTier)) * 100;
  }
};
